import styled from 'styled-components'

export const ContentContainer = styled.div`
    min-height: calc(100vh - 120px);
`
